import type { TableSessionModel } from '..';
import { includesSearch } from '../../search';
import { CARBON_UNIT, carbonOffsetFormat, chargingCostCostFormat, stopReasonMapper } from './format';

export function searchStopReason(searchValue: unknown, { stopReason }: TableSessionModel): boolean {
  return includesSearch(stopReasonMapper(stopReason), searchValue);
}

export function searchCarbonOffset(searchValue: unknown, { carbonOffset }: TableSessionModel): boolean {
  return !!carbonOffset && includesSearch(`${carbonOffsetFormat(carbonOffset)} ${CARBON_UNIT}`, searchValue);
}

export function searchTotalCarbonUsage(searchValue: unknown, { totalCarbonUsage }: TableSessionModel): boolean {
  return (
    totalCarbonUsage !== undefined &&
    includesSearch(`${totalCarbonUsage.toLocaleString(undefined, { maximumFractionDigits: 0 })} g CO2`, searchValue)
  );
}

export function searchChargingCost(args: { searchValue: unknown; cost: TableSessionModel['cost'] }): boolean {
  const { cost, searchValue } = args;
  return includesSearch(chargingCostCostFormat(cost), searchValue);
}
